export const TIER = {
  FREE: 'free',
  BUSINESS: 'business',
} as const;

export type Tier = (typeof TIER)[keyof typeof TIER];
